// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';

type Props = {
  bulletNavigation?: boolean,
};

export default styled<any, Theme, Props>('div')`
  position: relative;
  width: 100%;
  ${props => props.bulletNavigation && css`
    margin-bottom: 3.75rem;
  `}
`;
